/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAOffIcon16Solid = forwardRef('MediaAudioVolumeAOffIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.707.793a1 1 0 0 0-1.414 1.414L5.086 5H3.5A1.5 1.5 0 0 0 2 6.5v3A1.5 1.5 0 0 0 3.5 11h2.73l4.15 3.74c.625.563 1.62.12 1.62-.72v-2.106l2.293 2.293a1 1 0 0 0 1.414-1.414l-12-12Z" }),
        React.createElement("path", { d: "M12 1.98v5.222L8.107 3.308 10.38 1.26C11.005.697 12 1.14 12 1.98Z" })));
});
